import React from 'react'
import { Heading, Body } from '@superhi/design'

import IntroComponent from 'src/components/sections/Intro'

const Intro: React.FC<React.PropsWithChildren<unknown>> = () => (
  <IntroComponent
    left={
      <Heading level="3" as={'p'}>
        We&rsquo;re an online education platform and worldwide community of creatives learning
        together.
      </Heading>
    }
    right={
      <Body level="2">
        Founded in 2016, SuperHi is a global community of people learning together online, with some
        of the best teachers on the planet (though we may be biased). We&rsquo;ve taught code,
        design and project management skills to thousands of people in 90+ countries so that they
        can make, do, build, and grow without boundaries.
      </Body>
    }
  />
)

export default Intro
